import { defineStore } from 'pinia'
import { authApi } from '@/utils/api/auth'
import { clearSessionToken, setSessionToken } from '@/utils/api/client'

export const useUserStore = defineStore('user', {
  state: () => ({
    initialized: false,
    isLoggedIn: false,
    userId: '',
    userName: '',
    userEmail: '',
    pictureUrl: '',
    lineDisplayName: '',
    linePictureUrl: '',
    profileNickname: '',
    profileAvatarUrl: '',
    profileAvatarImageId: '',
    profileCompleted: false,
    profileUpdateCount: 0,
    profileUpdateRemaining: 3
  }),
  actions: {
    applyUser(user = null) {
      const displayName = user?.displayName || user?.name || ''
      const email = user?.email || ''

      this.userId = user?.userId || ''
      this.userName = displayName
      this.userEmail = email
      this.pictureUrl = user?.pictureUrl || ''
      this.lineDisplayName = user?.lineDisplayName || ''
      this.linePictureUrl = user?.linePictureUrl || ''
      this.profileNickname = user?.profileNickname || ''
      this.profileAvatarUrl = user?.profileAvatarUrl || ''
      this.profileAvatarImageId = user?.profileAvatarImageId || ''
      this.profileCompleted = user?.profileCompleted === true
      this.profileUpdateCount = Number(user?.profileUpdateCount || 0)
      this.profileUpdateRemaining = Number.isFinite(Number(user?.profileUpdateRemaining))
        ? Number(user.profileUpdateRemaining)
        : Math.max(0, 3 - this.profileUpdateCount)
    },
    setUser(_token, user = null) {
      setSessionToken(_token)
      this.isLoggedIn = true
      this.initialized = true
      if (user) {
        this.applyUser(user)
      }
    },
    setProfile(user = null) {
      this.applyUser({
        ...user,
        userId: this.userId,
        email: user?.email || this.userEmail
      })
    },
    clearSession() {
      this.initialized = true
      this.isLoggedIn = false
      this.userId = ''
      this.userName = ''
      this.userEmail = ''
      this.pictureUrl = ''
      this.lineDisplayName = ''
      this.linePictureUrl = ''
      this.profileNickname = ''
      this.profileAvatarUrl = ''
      this.profileAvatarImageId = ''
      this.profileCompleted = false
      this.profileUpdateCount = 0
      this.profileUpdateRemaining = 3
      clearSessionToken()
    },
    async initializeSession(force = false, sessionToken = '') {
      if (this.initialized && !force) {
        return this.isLoggedIn
      }

      try {
        if (sessionToken) {
          setSessionToken(sessionToken)
        }
        const response = await authApi.getSession()
        if (response?.authenticated && response.user) {
          this.isLoggedIn = true
          this.initialized = true
          this.applyUser(response.user)
          return true
        }
      } catch {
        // Session bootstrap should fail closed.
      }

      this.clearSession()
      return false
    },
    async logout() {
      try {
        await authApi.logout()
      } catch {
        // Local logout cleanup still runs even if the request fails.
      } finally {
        this.clearSession()
      }
    },
    checkLogin() {
      return this.isLoggedIn
    }
  }
})
